angular.module('app').directive('selecaoEmpresa', function($rootScope, $timeout) {
	return {
        restrict: 'A',
        templateUrl: 'assets/admin/html/selecao-empresa.html?v='+angular.element('meta[name="version-id"]').attr('content'), 
        controller: function($scope, $element, $http, $timeout, $compile) {
            $scope.empresaAtual = null;
            $scope.empresas = [];
        	$scope.obterEmpresas = function(){
                $http({
                    'url': 'admin/usuarios/minhas-empresas'
                }).then(function(res){
                    res.data.empresas.forEach(function(e){
                        if(e.vinculada){
                            $scope.empresas.push(e);
                        }
                    });
                    if(res.data.total > 1){
                        angular.element('[selecao-empresa]').removeClass('hide');
                    }
                });
            }

            $scope.definirEmpresaAtual = function(event, empresa_id){
                event.preventDefault();
                $http({
                    'url': 'admin/usuarios/definir-empresa-atual/'+empresa_id,
                    'method': 'post'
                }).then(function(res){
                    window.location.reload();
                });
            };
        },
        link: function ($scope, $element, attrs, ctrl) {
            $scope.empresaAtual = JSON.parse(attrs['empresaAtual']);
            $scope.obterEmpresas();
            $("[selecao-empresa] .dropdown-toggle").dropdown();
            $('[selecao-empresa] ul').on('click', function(e){		
                if($(e.target).prop('tagName')!='A' || $(e.target).attr('href')=='#'){
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        }
    };
});